<template>
  <svg
    id="gate"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 38 36"
    :fill="computedColor"
  >
    <path
      class="st0"
      d="M28.8,7H9c-1.5,0-2.7-.4-3.5-.8.1.7.3,1.4.6,1.9.4.8.9,1.3,1.4,1.3h22.7c.5,0,1-.6,1.4-1.3.3-.6.5-1.3.6-1.9-.8.4-2,.8-3.5.8h0ZM6.1,31.6c-.4,0-.7-.3-.7-.7s.3-.7.7-.7h2.5v-9.4h-2.4c-.6,0-1.2-.3-1.6-.7-.4-.4-.7-1-.7-1.6v-1.6c0-.4.3-.7.7-.7h3.9v-2.7h-.5c-.4,0-.7-.3-.7-.7v-2.1c-1,0-1.9-.9-2.5-2.1-.5-1.1-.9-2.4-.9-3.7s0-.2,0-.4c0-.2,0-.3.2-.5.3-.3.7-.3,1,0,0,0,1.2,1.3,3.8,1.3h19.8c2.4,0,3.6-1.2,3.8-1.3.1-.1.3-.2.5-.2.4,0,.7.3.7.7,0,.1,0,.3,0,.4h0c0,1.2-.3,2.6-.9,3.7-.6,1.2-1.5,2-2.5,2.1v2.1c0,.4-.3.7-.7.7h-.5v2.7h3.9c.4,0,.7.3.7.7v1.6c0,.6-.3,1.2-.7,1.6-.4.4-1,.7-1.6.7h-2.4v9.4h2.5c.4,0,.7.3.7.7s-.3.7-.7.7H6.1ZM10,30.2h1.5v-9.4h-1.5v9.4ZM12.9,30.2h11.9v-9.4h-11.9v9.4ZM26.2,30.2h1.5v-9.4h-1.5v9.4ZM10,16.3h1.5v-2.7h-1.5v2.7ZM12.9,16.3h3.8v-2.7h-3.8v2.7ZM18.1,16.3h1.5v-2.7h-1.5v2.7ZM21,16.3h3.8v-2.7h-3.8v2.7ZM26.2,16.3h1.5v-2.7h-1.5v2.7ZM32.4,17.7H5.4v.9c0,.2,0,.5.2.6.2.2.4.3.6.3h25.3c.2,0,.4,0,.6-.3.2-.2.2-.4.2-.6v-.9h0ZM8.8,10.8v1.3h20.2v-1.3H8.8h0Z"
    />
    <path
      class="st0"
      d="M28.8,7H9c-1.5,0-2.7-.4-3.5-.8.1.7.3,1.4.6,1.9.4.8.9,1.3,1.4,1.3h22.7c.5,0,1-.6,1.4-1.3.3-.6.5-1.3.6-1.9-.8.4-2,.8-3.5.8h0ZM6.1,31.6c-.4,0-.7-.3-.7-.7s.3-.7.7-.7h2.5v-9.4h-2.4c-.6,0-1.2-.3-1.6-.7-.4-.4-.7-1-.7-1.6v-1.6c0-.4.3-.7.7-.7h3.9v-2.7h-.5c-.4,0-.7-.3-.7-.7v-2.1c-1,0-1.9-.9-2.5-2.1-.5-1.1-.9-2.4-.9-3.7s0-.2,0-.4c0-.2,0-.3.2-.5.3-.3.7-.3,1,0,0,0,1.2,1.3,3.8,1.3h19.8c2.4,0,3.6-1.2,3.8-1.3.1-.1.3-.2.5-.2.4,0,.7.3.7.7,0,.1,0,.3,0,.4h0c0,1.2-.3,2.6-.9,3.7-.6,1.2-1.5,2-2.5,2.1v2.1c0,.4-.3.7-.7.7h-.5v2.7h3.9c.4,0,.7.3.7.7v1.6c0,.6-.3,1.2-.7,1.6-.4.4-1,.7-1.6.7h-2.4v9.4h2.5c.4,0,.7.3.7.7s-.3.7-.7.7H6.1ZM10,30.2h1.5v-9.4h-1.5v9.4ZM12.9,30.2h11.9v-9.4h-11.9v9.4ZM26.2,30.2h1.5v-9.4h-1.5v9.4ZM10,16.3h1.5v-2.7h-1.5v2.7ZM12.9,16.3h3.8v-2.7h-3.8v2.7ZM18.1,16.3h1.5v-2.7h-1.5v2.7ZM21,16.3h3.8v-2.7h-3.8v2.7ZM26.2,16.3h1.5v-2.7h-1.5v2.7ZM32.4,17.7H5.4v.9c0,.2,0,.5.2.6.2.2.4.3.6.3h25.3c.2,0,.4,0,.6-.3.2-.2.2-.4.2-.6v-.9h0ZM8.8,10.8v1.3h20.2v-1.3H8.8h0Z"
    />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  color: {
    type: String,
    default: "",
  },
});

const computedColor = computed(() => props.color || "currentColor");
</script>
